/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTS41LjV2MTVoMTVWLjVabTE0LDFWNS4ySDEuNVYxLjVaTTYuMiw5LjhWNi4ySDkuOFY5LjhabTMuNywxdjMuN0g2LjJWMTAuOFptLTQuNy0xSDEuNVY2LjJINS4yWm01LjctMy43aDMuN1Y5LjhIMTAuOFpNMS41LDEwLjhINS4ydjMuN0gxLjVabTkuMywzLjdWMTAuOGgzLjd2My43WiIvPjwvc3ZnPg==";